export const getInventoryOrderList = state => {
    return state.list
}

export const getInventoryOrderDataProps = state => {
    return state.props
}

export const getInventoryOrderRequestList = state => {
    return state.request_list
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryOrder/getters.js